module.exports = __webpack_public_path__ + "img/info.605ee462.svg";